import { IValidation } from "./";

const Validation: IValidation = {
  error: "Por favor, digite um número de telefone válido",
  validate: (input: string) => {
    return /\(?(?:[1468][1-9]|2[12478]|3[1234578]|5[1345]|7[134579]|9[1234567])\)?\s?(?:[2-5][0-9]{3}-[0-9]{4}|[789][0-9]{4}-[0-9]{4})$/.test(
      input
    );
  },
};

export default Validation;
